export default {
    dataSource: {
        save: '/basic/datasource/save', // 新增用户
        delete: '/basic/datasource/del', // 新增用户
        update: '/basic/datasource/update', // 修改人员
        list: '/basic/datasource/queryDataSourceList', // 用户列表查询
        code: '/basic/datatype/list', // 用户列表查询
        text: '/basic/datasource/test' // 测试数据源连接性
    },
    tenant: {
        save: '/basic/tenant/save', // 新增用户
        delete: '/basic/tenant/del', // 删除用户
        update: '/basic/tenant/update', // 修改人员
        list: '/basic/tenant/queryTenantPageList', // 用户列表查询
        batch: 'basic/tenant/batch', // 批量操作
        export: '/basic/tenant/downloadUserListInfo', // 导出
        tag: '/basic/tags', // 导出
        tagList: '/basic/tags/getList' // 导出
    },
    role: {
        tree: {
            save: '/basic/platforms', // 添加组织
            update: '/basic/platforms/batch', // 批量激活、冻结、删除组织节点
            info: '/basic/platforms/query/', // 编辑时查询单个组织节点数据
            modify: '/basic/platforms/update', // 修改
            tree: '/basic/platforms/queryTreeList', // 异步查询组织树
            queryAuthTreeBrch: '/basic/brch/authUserTreeBrch', // 角色授权异步树接口
            authorize: '/basic/roles/authorize', // 角色授权确定接口
            tenantAuthorization: '/tenant/tenantAuthorization' // 角色授权确定接口
        },
        save: '/basic/roles', // 新增用户
        delete: '/basic/roles/', // 删除用户
        update: '/basic/roles/update', // 修改人员
        list: '/basic/roles/queryRoleList', // 用户列表查询
        batch: 'basic/roles/batch', // 批量操作
        export: '/basic/roles/downloadRoleList', // 导出
        queryUserRoleAuthorizationed: '/basic/users/queryUserRoleAuthorizationed' // 角色默认值
    }
};
